<template>
    <div class="formwork-two" @click="jump(row)">
      <div class="box-left">
        <div v-if="!row.IsOffline" class="content">{{row.Title}}</div>
        <div v-else class="text-big text-bold">该发布内容已下线</div>
        <div class="row-flex-between info">
          <span v-if="!$slots.default">{{row.DisplayTime | datetime-second-parse}}</span>
          <slot></slot>
          <span>阅读{{row.CountNum}}</span>
        </div>
      </div>
      <div class="box-right">
        <LazyImg class="lazy-img" :imgUrl="row.CoverImage"></LazyImg>
        <div v-show="row.VideoDuration" class="video-tips">
          <van-icon name="play"/>
          <span>{{row.VideoDuration | duration}}</span>            
        </div>
      </div>
    </div>
</template>

<script>
import LazyImg from '@/components/lazyImg'
export default {
  name: 'formworkTwo',
  components: { LazyImg },
  props: {
    row: {
      type: Object
    }
  },
  methods: {
    jump(row) {
      this.$router.push({ name: 'detail', params: { id: row.ArticleId }, query: { id: row.ArticleId } })
    }
  }
}
</script>

<style lang="scss" scoped>
.formwork-two {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  background: #fff;
  .box-left {
    position: relative;
    margin-right: 7px;
    .content {
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      line-height: 20px;
      font-size: 15px;
    }
    .info {
      position: absolute;
      bottom: 0;
      width: 100%;
      font-size: $font-size-small;
      color: $gray-deep;
      span {
        @include text-overflow;
      }
      & span:nth-child(1) {
        width: 70vh;
      }
      & span:nth-child(2) {
        width: 30vh;
        text-align: right;
      }
    }
    flex: auto;
  }

  .box-right {
    position: relative;
    width: 84px;
    height: 60px;
    flex: none;
    .lazy-img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
